import { showMessages } from '@intercom/messenger-js-sdk';
import { Button } from '@synoptic/ui-kit/button/button.js';
import { ChatBubbleEmptyIcon } from '@synoptic/ui-kit/icons/react/chat-bubble-empty.js';
import { MailIcon } from '@synoptic/ui-kit/icons/react/mail.js';
import {
  ModalContent,
  ModalRoot,
  ModalTrigger,
  ModalHeader,
  ModalTitle,
} from '@synoptic/ui-kit/modal/modal.js';
import clsx from 'clsx';
import { Link } from '@/routes-utils/navigation.tsx';
import { menuItemButton, menuItemText } from './menu-action.css.ts';
import {
  modalContent,
  modalActions,
  modalButton,
  modalDescription,
} from './request-access-menu-modal.css.ts';

export const RequestAccessMenuModal = ({
  label,
  modalDescriptionContent,
  modalActionsContent,
  icon,
  className,
}: {
  label: string;
  modalDescriptionContent: string;
  modalActionsContent?: React.ReactNode;
  icon: React.ReactNode;
  className?: string;
}) => {
  return (
    <ModalRoot>
      <ModalTrigger asChild>
        <Button
          className={clsx(menuItemButton, className)}
          startIcon={icon}
          variant="ghost"
        >
          <span className={menuItemText}>{label}</span>
        </Button>
      </ModalTrigger>
      <ModalContent>
        <ModalHeader>
          <ModalTitle>{label}</ModalTitle>
        </ModalHeader>
        <div className={modalContent}>
          <p className={modalDescription}>{modalDescriptionContent}</p>
          <div className={modalActions}>
            {modalActionsContent ? (
              modalActionsContent
            ) : (
              <>
                <Button
                  variant="primary"
                  startIcon={<ChatBubbleEmptyIcon />}
                  onClick={() => showMessages()}
                  className={modalButton}
                >
                  Open Support Chat
                </Button>

                <Button
                  variant="secondary"
                  startIcon={<MailIcon />}
                  className={modalButton}
                  asChild
                >
                  <Link to="mailto:info@synoptic.com">Email us</Link>
                </Button>
              </>
            )}
          </div>
        </div>
      </ModalContent>
    </ModalRoot>
  );
};
